const translations = {
  title: "Physical Stock Inventory",
  subtitle: "Finished jewellery stock management, barcoding, and search.",
  // Tabs
  tab_inventory: "Inventory",
  tab_movements: "Movements",
  tab_barcode: "Barcode & Tags",
  // Search / Filter
  searchPlaceholder: "Search by name, barcode, HUID, category…",
  filterByCategory: "Category",
  filterByStatus: "Status",
  filterByPurity: "Purity",
  allCategories: "All Categories",
  allStatuses: "All",
  // Item Fields
  itemName: "Item Name",
  category: "Category",
  barcode: "Barcode",
  huid: "HUID",
  purity: "Purity",
  grossWeight: "Gross Wt (g)",
  netWeight: "Net Wt (g)",
  stoneWeight: "Stone Wt (g)",
  fineGold: "Fine Gold (g)",
  goldRate: "Gold Rate (₹/g)",
  makingCharge: "Making Charge (₹)",
  salePrice: "Sale Price (₹)",
  costPrice: "Cost Price (₹)",
  location: "Location / Tray",
  description: "Description",
  notes: "Notes",
  images: "Images",
  // Status
  status_available: "Available",
  status_reserved: "Reserved",
  status_sold: "Sold",
  status_returned: "Returned",
  status_damaged: "Damaged",
  // Actions
  addItem: "Add Stock Item",
  editItem: "Edit Item",
  deleteItem: "Delete Item",
  printTag: "Print Tag",
  markSold: "Mark as Sold",
  markAvailable: "Mark as Available",
  reserveItem: "Reserve Item",
  // Movements
  movements: "Stock Movements",
  movementType: "Movement Type",
  movementDate: "Date",
  movementQty: "Quantity",
  movementWeight: "Weight",
  movementRef: "Reference",
  move_in: "Stock In",
  move_out: "Stock Out",
  move_transfer: "Transfer",
  move_adjustment: "Adjustment",
  move_return: "Return",
  // Barcode & Tagging
  barcodeTagging: "Barcode & Tagging",
  printBarcode: "Print Barcode Label",
  scanBarcode: "Scan Barcode",
  barcodeFormat: "Label Format",
  tagLayout: "Tag Layout",
  printCopies: "Copies",
  // Summary
  totalItems: "Total Items",
  totalValue: "Total Value (₹)",
  availableItems: "Available",
  soldItems: "Sold",
  // Empty states
  noItems: "No stock items yet.",
  addFirstItem: "Add the first item to begin tracking inventory.",
  noMovements: "No movements recorded.",
  // Columns
  col_barcode: "Barcode",
  col_name: "Item",
  col_category: "Category",
  col_purity: "Purity",
  col_grossWt: "Gross Wt",
  col_fineGold: "Fine Gold",
  col_price: "Price",
  col_status: "Status",
  col_location: "Location",
  col_action: "Action",
};

export default translations;
